<template>
	<b-img :src="src" :alt="alt" :fluid="fluid"/>
</template>

<script>
export default {

	props: {
		path: {
			type: String,
			required: true,
		},
		alt: {
			type: String,
			required: true,
		},
		fluid: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	computed: {
		src ()
		{
			return '/img/' + this.path;
		}
	}
}
</script>
